"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeocoderService = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const i18n_1 = require("../i18n");
const index_1 = require("./index");
/**
 * https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
 */
const ADDRESS_TYPES = {
    CITY: 'locality',
    STATE: 'administrative_area_level_1'
};
class GeocoderService {
    constructor() {
        this.__priority = 100;
        this.isReady = false;
    }
    init() {
        this.isReadyPromise = new Promise(resolve => {
            const waitForGoogleGeocoder = index_1.Services.Window.window.setInterval(() => {
                if (typeof google === 'undefined') {
                    return;
                }
                index_1.Services.Window.window.clearTimeout(waitForGoogleGeocoder);
                this.setIsReady();
                resolve();
            }, 10);
        });
    }
    setIsReady() {
        this.isReady = true;
    }
    getLatLng(location) {
        const latLng = new google.maps.LatLng(location.coordinates[1], location.coordinates[0]);
        return latLng;
    }
    getGeocoderRequest(location) {
        const geocoderRequest = {
            location,
            language: 'en'
        };
        return geocoderRequest;
    }
    geocoderResult(location) {
        return new Promise((resolve, reject) => {
            if (this.geocoder == null) {
                this.geocoder = new google.maps.Geocoder();
            }
            const latLng = this.getLatLng(location);
            const geocoderRequest = this.getGeocoderRequest(latLng);
            this.geocoder.geocode((geocoderRequest), (results, status) => {
                if (status.toString() === 'OK') {
                    resolve(results[0]);
                }
                else {
                    reject(status);
                }
            });
        });
    }
    getAddress(location) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.isReady) {
                throw new Error('Cannot fetch geocode before Google Maps API loaded');
            }
            let result = {
                address: null,
                city: null,
                state: null
            };
            try {
                const geoCoderResult = yield this.geocoderResult(location);
                index_1.Services.Log.Logger.info(geoCoderResult.formatted_address);
                result.address = geoCoderResult.formatted_address;
                for (const component of geoCoderResult.address_components) {
                    if (component.types.indexOf(ADDRESS_TYPES.CITY) > -1) {
                        result.city = component.long_name;
                    }
                    if (component.types.indexOf(ADDRESS_TYPES.STATE) > -1) {
                        result.state = component.long_name;
                    }
                }
                return result;
            }
            catch (err) {
                index_1.Services.Log.Logger.error(err);
                result.address = (0, i18n_1.Translate)(i18n_1.T.ERROR_GENERAL);
                return result;
            }
        });
    }
}
exports.GeocoderService = GeocoderService;
tslib_1.__decorate([
    mobx_1.observable
], GeocoderService.prototype, "isReady", void 0);
tslib_1.__decorate([
    mobx_1.action
], GeocoderService.prototype, "setIsReady", null);
//# sourceMappingURL=geocoder.service.js.map